import {Switch} from "@mui/material";
import {ErrorMessage, Field} from "formik";
import { useEffect, useState } from "react";
import {useIntl} from "react-intl";
import {Col, FormGroup, Label, Row} from "reactstrap";
import { AdminService } from "../../../services";
import './applicant-info.scss';


interface AplicantOptionsProps {
    errors?: any;
    values?: any;
    pwsCodCredi: string;
}
export function AplicantOptions(props: AplicantOptionsProps) {
    const {errors, pwsCodCredi} = props;
    const intl = useIntl();
    const [one] =useState(false)
    const [allOcupaciones, SetAllOcupaciones] = useState([]);
    
    useEffect(()=>{
        getAlldata()
    },[one])
    
    const getAlldata = async () => {
        const response = await AdminService.getOcupaciones();
        if (response.payload.data.ListOcup.Datos_Ocupaciones.length > 0) {
            SetAllOcupaciones(response.payload.data.ListOcup.Datos_Ocupaciones);
        }
      };
    
      const filterOcupaciones = () => {
        return allOcupaciones;
      };
      const renderSelectOptions = () => {
        return (
          <>
            <option value="">
              Seleccione...
            </option>
            {filterOcupaciones().map((item: any, key) => (
              <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
            ))}
          </>
        );
      };
    return (
        <div className="applicant-options-wrapper">
            <Row className="container-border-app-options applicant-options-panel">
                <Col xl={"3"} lg={"4"} sm={"12"} md={"6"} xs={"12"} className="applicant-option-field">
                    <section>
                        <Label className="label-form display-flex" for="Pws_Tip_person">
                            {intl.formatMessage({id: "who_accredits_motorcycle"})}
                        </Label>
                        <br/>
                        <div className="display-flex">
                            <Field as="select"
                                   className={`${errors.Pws_Tip_person ? 'form-know-you-item-input-smaller-2 display-flex input-error' : 'form-know-you-item-input-smaller-2 display-flex'}`}
                                   name="Pws_Tip_person">
                                <option value="">{'Seleccione...'}</option>
                                <option value={'N'}>{'Natural'}</option>
                                <option value={'J'}>{'Juridico'}</option>
                            </Field>
                            <div className="label-fields-peps-warning">
                                <ErrorMessage name="Pws_Tip_person"/>
                            </div>
                        </div>
                    </section>
                </Col>
                <Col xl={"3"} lg={"4"} sm={"12"} md={"6"} xs={"12"} className="applicant-option-field">
                    <FormGroup>
                        <Label className="label-form display-flex" for="Pws_Tip_ocupa">
                            {intl.formatMessage({id: "placeholder_occupation_type"})}
                        </Label>
                        <br/>
                        <div className="display-flex">
                            <Field as="select"
                                   className={`${errors.Pws_Tip_ocupa ? 'form-know-you-item-input-smaller-2 display-flex input-error' : 'form-know-you-item-input-smaller-2 display-flex'}`}
                                   name="Pws_Tip_ocupa">
                                {renderSelectOptions()}
                            </Field>
                            <div className="label-fields-peps-warning">
                                <ErrorMessage name="Pws_Tip_ocupa"/>
                            </div>
                        </div>
                    </FormGroup>
                </Col>
                <Col className="applicant-option-field applicant-option-field-hidden" xl={"3"} lg={"2"} sm={"6"} md={"2"}>
                    {/* <FormGroup>
                        <Label className="label-form display-flex" for="Pws_Fideliza">
                            {intl.formatMessage({id: "loyalty"})}
                        </Label>
                        <br/>
                        <div className="col-3 toggle-app">{intl.formatMessage({id: "button_no"})}<Field
                            name="Pws_Fideliza" component={Switch}
                            type="checkbox"/>{intl.formatMessage({id: "button_yes"})}</div>
                    </FormGroup> */}
                </Col>
            </Row>
        </div>
    )
}
